import { ProductSelectDto } from '@@types/api.types';
import { IconButton } from '@components/core/icon-button.component';
import { BlueLabel } from '@components/shared/blue-label.component';
import { Tile } from '@components/shared/tile.component';
import { EditIcon } from 'lucide-react';
import { useState } from 'react';
import { ExpandableText } from '../../../shared/expandable-text.component';

type ProductHeaderProps = {
  isLoading?: boolean;
  onEditClick?: () => void;
  product?: ProductSelectDto;
};

export const ProductHeader: React.FC<ProductHeaderProps> = (props) => {
  const { isLoading, onEditClick, product } = props;
  const [isHovering, setIsHovering] = useState(false);
  const canEdit = Boolean(onEditClick);

  const handleEditClick = () => {
    onEditClick && onEditClick();
  };

  return (
    <Tile
      className="min-h-[106px]"
      isLoading={isLoading}
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
    >
      <div className="flex flex-col gap-4">
        <div className="flex flex-row justify-between w-full">
          <div className="flex flex-col">
            <div className="text-[20px] font-medium text-gray-800">{product?.name}</div>
            <BlueLabel text="Product" />
          </div>
          <div className="flex flex-col justify-between items-end">
            {canEdit && (
              <IconButton
                ariaLabel="Edit Product"
                icon={<EditIcon />}
                isVisible={isHovering}
                onClick={handleEditClick}
                variant="secondary"
              />
            )}
          </div>
        </div>
        {product?.description && (
          <ExpandableText
            className="text-xs font-normal text-gray-500"
            text={product.description}
            maxLines={2}
          />
        )}
      </div>
    </Tile>
  );
};
